// THIS FILE IS GENERATED, DO NOT EDIT!
/* eslint-disable */
import * as Types from '@h5s/dtos-api';

import { LocalDate, LocalDateTime, LocalTime } from '@h5s/util-date';
import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type SendIstatMutationVariables = Types.Exact<{
  sendIstatRequestDTO: Types.SendIstatRequestDtoInput;
}>;


export type SendIstatMutationResult = { __typename?: 'Mutation', sendIstat: string | null };

export const SendIstatGql = gql`
    mutation SendIstat($sendIstatRequestDTO: SendIstatRequestDTOInput!) {
  sendIstat(sendIstatRequestDTO: $sendIstatRequestDTO)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SendIstatInjectable extends Apollo.Mutation<SendIstatMutationResult, SendIstatMutationVariables> {
    override document = SendIstatGql;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
/* eslint-enable */